import React from "react";
import dogimg from "../../../images/cltrnd.png";
import rocks from "../../../images/cltrnd1.png";
import { useNavigate } from "react-router-dom";

const CollectionCard = ({
  title,
  type,
  description,
  nftCount,
  imgSrc,
  typeShow
}) => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate(`/marketplace?nft_type=${type}`);
  };
  return (
    <div className="card flex flex-col lg:flex-row justify-between gap-8 lg:gap-16 bg-black p-4 sm:px-8 sm:py-12 rounded-2xl">
      <div className="icon-wrapper flex flex-col gap-8 lg:gap-12 lg:min-w-[11.875rem]">
        <div className="flex -space-x-6 overflow-hidden">
          <img
            src={dogimg}
            alt="not-found"
            className="w-16 h-16 lg:w-20 lg:h-20 object-contain rounded-full"
          />
          <img
            src={rocks}
            alt="not-found"
            className="w-16 h-16 lg:w-20 lg:h-20 object-contain rounded-full"
          />
        </div>
        <div className="flex flex-col gap-4">
          <p className="m-0 text-yellowbuy text-[1.5rem] md:text-[2rem] leading-[1] font-bold">
            NFTs
          </p>
          <h6 className="m-0 text-yellowbuy text-[3rem] md:text-[6rem] xl:text-[7rem] leading-[1] font-bold">
            {nftCount}+
          </h6>
        </div>
      </div>
      <div className="flex flex-col md:flex-row gap-8 lg:gap-16 flex-1">
        <div className="content-wrapper flex-1">
          <div className="flex flex-col gap-4">
            <div className="title-wrapper flex flex-col gap-1.5">
              <h2 className="m-0 text-white text-2xl font-bold">{title}</h2>
              <p className="m-0 text-[#FFFFFF9E] font-bold leading-6 text-base">
                {typeShow}
              </p>
            </div>
            <p className="m-0 text-[#FFFFFF] font-normal leading-6 text-base">
              {description}
            </p>
            <button
              type="button"
              onClick={() => handleNavigate()}
              className="flex justify-center items-center gap-1 w-fit rounded-full bg-yellowbuy border border-[#000000] px-6 py-2 text-base font-normal text-black"
            >
              EXPLORE
            </button>
          </div>
        </div>
        <div className="image-wrapper flex-1">
          <img
            src={imgSrc}
            alt={title}
            className="w-full h-full object-cover border border-yellowbuy rounded-2xl"
          />
        </div>
      </div>
    </div>
  );
};

export default CollectionCard;
